export default {
  loading: false,
  forms: [],
  form: {},
  totalCount: 0,
};
